import * as React from 'react';

import { Box, H3, Text } from '@opendoor/bricks/core';

import { CasaAddress } from './UnsubscribePage';

interface IErrorPageProps {
  casaAddress: CasaAddress | null;
}

export class ErrorPage extends React.PureComponent<IErrorPageProps> {
  public render() {
    const { casaAddress } = this.props;
    const unit =
      casaAddress && casaAddress.unitNumber && casaAddress.unitNumber
        ? casaAddress.unitType + ' ' + casaAddress.unitNumber
        : null;

    return (
      <Box maxWidth="600px">
        <H3 width="100%" textAlign={['center', null, 'left']} mb={7}>
          Something went wrong
        </H3>
        <Text textAlign={['center', null, 'left']} mb={7}>
          There was a problem unsubscribing {casaAddress ? casaAddress.street : 'your home'}
          {unit && `, ${unit}`} from our mailing list. Please email your full address to
          mail@opendoor.com to unsubscribe.
        </Text>
      </Box>
    );
  }
}
